export const CLI_PACKAGE_NAME = 'betterstart-cli'
export const REDACTED = '[redacted]'
